module.exports = __webpack_public_path__ + "static/wakefield-free-bus-sm-d0eb0968475ca1404477a8e32ea6c4f2.jpg";